// extracted by mini-css-extract-plugin
export default {"root":"second_root__cr39x","title":"second_title__jWkyE","carousel":"second_carousel__QnQ5j","explore-all-btn":"second_explore-all-btn__oSry3"};